import AwrabetDatalistInput from "../../awrabet/utils/datalist-input";

export default class DatalistInput extends AwrabetDatalistInput {
    render({
        list = [],
        containerclass = null,
        inputclass = null,
        inputid = null,
        suggestclass = null,
        itemclass = null,
        onInput = null,
        placeholder = null
    }) {
        return <div ref={r => this.root = r} class={"inline-block relative" + (!!containerclass? ' ' + containerclass : '')}>
            <input
                id={inputid}
                type="text"
                autocomplete="off"
                value={this.state.inputvalue}
                onInput={e => this.inputCallback(e)}
                class={(!!inputclass? inputclass : '')}
                onFocus={e => this.setState({showsuggest: true})}
                placeholder={placeholder}
            />
            {!!this.state.showsuggest && !!this.state.lastsearch.searchresults.length && <div class={(!!suggestclass? suggestclass + ' ' : 'w-full left-0 border border-gray-300 rounded-b z-30 bg-white shadow-md') + " fixed"}>
                {!!this.state.showloading && <div class="fixed z-40 top-0 left-0 right-0 bottom-0 opacity-50 bg-black text-white text-center">
                    <i class="fa fa-cog fa-spin absolute" style="top:47%;left:46%" />
                </div>}
                {!!this.state.lastsearch.searchresults && <div class="overflow-auto" style="max-height:200px; min-height:30px">
                    {this.state.lastsearch.searchresults.map(
                    item => <a
                        href="javascript:void(0);"
                        class={(!!itemclass? itemclass + ' ' : 'p-2 text-xs truncate hover:bg-blue-200 ') + "block"}
                        onClick={e => this.inputCallback({target:{value:item.value}}, false, item)}
                    >
                        {item.label}
                    </a>)}
                </div>}
            </div>}
        </div>;
    }
}